<template>
  <header class="header">
    <a href="/" class="header__logo">JUST 2 DAYS</a>
    <div class="header__user" v-if="isLogin">
      <span>{{ $store.state.loginId }}님</span>
      <button class="btn btn--ghost" style="width:auto;padding:0.4rem 1rem;" @click="logout">로그아웃</button>
    </div>

  </header>

  <section class="page__section">
    <router-view></router-view>
  </section>

  <footer class="footer">
    <button class="footer__add-btn" v-if="isLogin" @click="$router.push('/writeContent')" title="글쓰기">+</button>
  </footer>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import instance from './axiosInterceptor.js'

export default {
  name: 'App',
  computed: {
    ...mapState(['loginId', 'isLogin']),
  },
  methods: {
    ...mapMutations(['setLoginId']),

    /**
     * 로그아웃
     * [SECURITY] 서버에 refreshToken 무효화 요청 추가
     *   - 기존: localStorage 만 지우고 끝 → 서버 refreshToken 은 살아있었음
     *   - 변경: /api/logout 에 userId 전송 → DB의 refreshToken 을 "" 로 초기화
     *   - 실패해도 클라이언트는 정상 로그아웃 처리 (UX 우선)
     */
    async logout() {
      try {
        await instance.post(process.env.VUE_APP_API_SERVER_URL + '/api/logout', {
          userId: this.$store.state.loginId,
        });
      } catch (e) {
        // 서버 요청 실패해도 클라이언트는 로그아웃 처리
        console.warn('logout server request failed:', e);
      } finally {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        this.$store.commit('logout');
        this.$router.push('/loginPage');
      }
    },
  },
  mounted() {
    const at = localStorage.getItem('accessToken');
    if (at) {
      this.$store.dispatch('loginCheck');
    }
  },
}
</script>

<style lang="scss">
/* 전역 스타일은 vue.config.js의 additionalData에서 자동 주입됨 */
</style>
